import { createContext, useContext } from 'react';

import { createAITTheme } from '../theme';

export const AITThemeContext = createContext({ theme: createAITTheme() });
export const useAITTheme = () => useContext(AITThemeContext);
